import { render, staticRenderFns } from "./expense_expand.vue?vue&type=template&id=3bb7d51e&scoped=true"
import script from "./expense_expand.vue?vue&type=script&lang=js"
export * from "./expense_expand.vue?vue&type=script&lang=js"
import style0 from "./expense_expand.vue?vue&type=style&index=0&id=3bb7d51e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb7d51e",
  null
  
)

export default component.exports